import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { get as _get } from 'lodash';
import { Driver } from '../../../Constants/DriverConstants';

export interface AutoClaimDetails {
  year: string;
  make: string;
  model: string;
  vin: string;
}

export interface Reporter {
  contactReferenceKey: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  relationshipToInsured: string;
}

export interface ContactInfo {
  emailAddress: string;
  phoneNumber: string;
}

export interface LossLocationAddress {
  addressLine1: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}
export interface ClaimCreationState {
  reporterInfo: Reporter | undefined;
  riskInfo: any | undefined;
  driverInfo: Driver | undefined;
  dateLocationInfo: any | undefined;
  draftPayload: any | undefined;
  isGlassClaim: boolean;
  isErsClaim: boolean;
}

const initialState: ClaimCreationState = {
  reporterInfo: {
    contactReferenceKey: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    relationshipToInsured: 'Self',
  },
  riskInfo: undefined,
  driverInfo: undefined,
  dateLocationInfo: undefined,
  draftPayload: undefined,
  isGlassClaim: false,
  isErsClaim: false,
};

const claimCreationSlice = createSlice({
  name: 'claimCreation',
  initialState,
  reducers: {
    addFnolRisk(state, action: PayloadAction<{ riskInfo: any }>) {
      state.riskInfo = action.payload.riskInfo;
    },
    addFnolReporter(state, action: PayloadAction<{ reporterInfo: Reporter }>) {
      state.reporterInfo = action.payload.reporterInfo;
    },
    addDriver(state, action: PayloadAction<{ driverInfo: Driver }>) {
      state.driverInfo = action.payload.driverInfo;
    },
    saveDateLocation(state, action: PayloadAction<{ dateLocationInfo: any }>) {
      state.dateLocationInfo = action.payload.dateLocationInfo;
    },
    updateClaimInsureds(state, action: PayloadAction<{ insureds: any[] }>) {
      action.payload.insureds.forEach((insured: any) => {
        if (state.reporterInfo && insured.contactReferenceKey === _get(state, 'reporterInfo.contactReferenceKey', '')) {
          state.reporterInfo.firstName = _get(insured, 'firstName', _get(state, 'reporterInfo.firstName', ''));

          state.reporterInfo.lastName = _get(insured, 'lastName', _get(state, 'reporterInfo.lastName', ''));
        }
      });
      if (_get(state, 'riskInfo.policy.policyRoles')) {
        state.riskInfo.policy.policyRoles = action.payload.insureds;
      }
    },
    updateReporterContactInfo(state, action: PayloadAction<{ contactInfo: ContactInfo }>) {
      if (state.reporterInfo) {
        state.reporterInfo.phoneNumber = action.payload.contactInfo.phoneNumber;
        state.reporterInfo.emailAddress = action.payload.contactInfo.emailAddress;
      }
    },
    updateDraftPayload(state, action: PayloadAction<{ draftPayload: any }>) {
      state.draftPayload = action.payload.draftPayload;
    },
    setGlassClaim(state, action: PayloadAction<{ isGlassClaim: boolean }>) {
      state.isGlassClaim = action.payload.isGlassClaim;
    },
    setErsClaim(state, action: PayloadAction<{ isErsClaim: boolean }>) {
      state.isErsClaim = action.payload.isErsClaim;
    },
  },
});

export const {
  addFnolRisk,
  addFnolReporter,
  addDriver,
  saveDateLocation,
  updateClaimInsureds,
  updateReporterContactInfo,
  updateDraftPayload,
  setGlassClaim,
  setErsClaim,
} = claimCreationSlice.actions;
export default claimCreationSlice.reducer;
